import { render, staticRenderFns } from "./AdmonitionEdit.vue?vue&type=template&id=391b4602"
import script from "./AdmonitionEdit.vue?vue&type=script&lang=js"
export * from "./AdmonitionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports